import { BASE_PATH_API } from '@manager-base/app-base/environment/paths/constants';
import { createActions } from '@manager-base/app-base/config/data-access';

const actions = {
    get: {
        method: 'GET',
        cache: true,
        url: `${BASE_PATH_API}/settings/global`
    },
    queryTimeZones: {
        method: 'GET',
        url: `${BASE_PATH_API}/lookup/timeZones`
    },
    queryCountries: {
        method: 'GET',
        url: `${BASE_PATH_API}/lookup/countries`
    },
    saveRegionalSettings: {
        method: 'POST',
        url: `${BASE_PATH_API}/settings/regional`
    },
    getRegionalSettings: {
        method: 'GET',
        url: `${BASE_PATH_API}/settings/regional`
    },
    getRegionalSampleData: {
        method: 'GET',
        url: `${BASE_PATH_API}/settings/regionalSampleData`
    },
    saveManagementFeePolicy: {
        method: 'PUT',
        url: `${BASE_PATH_API}/settings/managementFeePolicy`,
        transformRequestData: function transformRequestData(data) {
            if (data.ManagementRevenueAccounts) {
                data.ManagementRevenueAccounts = data.ManagementRevenueAccounts.filter(x => !!x);
            }

            if (data.ManagementNonCommissionableAccounts) {
                data.ManagementNonCommissionableAccounts = data.ManagementNonCommissionableAccounts.filter(x => !!x);
            }

            if (data.id && data.Id) {
                delete data.id;
            }

            return data;
        }
    },
    saveManagementFeePolicyFeeType: {
        method: 'PUT',
        url: `${BASE_PATH_API}/settings/managementFeePolicy/feeType`,
        transformRequestData: function transformRequestData(data) {
            if (data && data.id && data.Id) {
                delete data.id;
            }

            return data;
        }
    },
    saveManagementFeePolicyFeeIncomeAccounts: {
        method: 'PUT',
        url: `${BASE_PATH_API}/settings/managementFeePolicy/incomeAccounts`,
        transformRequestData: function transformRequestData(data) {
            if (data && data.id && data.Id) {
                delete data.id;
            }

            return data;
        }
    },
    saveManagementFeePolicyNonCommisionableAccounts: {
        method: 'PUT',
        url: `${BASE_PATH_API}/settings/managementFeePolicy/nonCommissionableAccounts`,
        transformRequestData: function transformRequestData(data) {
            if (data && data.id && data.Id) {
                delete data.id;
            }

            return data;
        }
    },
    getCompanyManagementFeePolicy: {
        method: 'GET',
        url: `${BASE_PATH_API}/settings/managementFeePolicy/company`
    },
    getManagementFeePolicy: {
        method: 'GET',
        url: `${BASE_PATH_API}/settings/managementFeePolicy/:propertyId`
    },
    deletePropertyManagementFeePolicy: {
        method: 'DELETE',
        url: `${BASE_PATH_API}/settings/managementFeePolicy/:propertyId`
    },
    doesVendorHaveManagementFeePolicies: {
        method: 'GET',
        url: `${BASE_PATH_API}/settings/managementFeePolicy/exists/:vendorId`
    },
    doesCompanyHaveManagementFeePolicyIncomeAccounts: {
        method: 'GET',
        url: `${BASE_PATH_API}/settings/managementFeePolicy/hasIncomeAccounts`
    },

    doesUserAccessAppSettings: {
        method: 'GET',
        url: `${BASE_PATH_API}/settings/accessSettingsPermission`
    },
    getPremiumTenantScreeningAccessStatus: {
        method: 'GET',
        url: `${BASE_PATH_API}/settings/accessPremiumTenantScreening`
    },
    isApprovedForPremiumTenantScreening: {
        method: 'GET',
        url: `${BASE_PATH_API}/settings/isApprovedForPremiumTenantScreening`
    },
    isAiTenantScreeningEnabled: {
        method: 'GET',
        url: `${BASE_PATH_API}/settings/isAiTenantScreeningEnabled`
    },
    getPropertyTypeSettings: {
        method: 'GET',
        url: `${BASE_PATH_API}/settings/propertyTypes`
    },
    savePropertyTypeSettings: {
        method: 'POST',
        url: `${BASE_PATH_API}/settings/propertyTypes`
    },
    getReportSettings: {
        method: 'GET',
        url: `${BASE_PATH_API}/settings/reports`
    },
    saveReportSettings: {
        method: 'POST',
        url: `${BASE_PATH_API}/settings/reports`
    },
    getAccountingSettings: {
        method: 'GET',
        url: `${BASE_PATH_API}/settings/accounting`
    },
    saveAccountingSettings: {
        method: 'POST',
        url: `${BASE_PATH_API}/settings/accounting`
    },
    getPrinterSettings: {
        method: 'GET',
        url: `${BASE_PATH_API}/settings/printer`
    },
    savePrinterSettings: {
        method: 'POST',
        url: `${BASE_PATH_API}/settings/printer`
    },
    isPhonesAvailable: {
        method: 'GET',
        url: `${BASE_PATH_API}/settings/isPhonesAvailable`
    },
    // Zuora calls
    // --------------------------------------------------------
    // Gets products from zuora
    getZuoraProductCatalog: {
        method: 'GET',
        isArray: true,
        url: `${BASE_PATH_API}/billing/pricingPlans`
    },
    getUnfilteredZuoraProductCatalog: {
        method: 'GET',
        isArray: true,
        url: `${BASE_PATH_API}/billing/unfilteredPricingPlans`
    },
    // Gets required tokens to render form
    getZuoraSignature: {
        method: 'POST',
        url: `${BASE_PATH_API}/billing/digitalPaymentSignature`
    },
    subscription: {
        method: 'POST',
        url: `${BASE_PATH_API}/billing/subscription`
    },
    previewSubscription: {
        method: 'POST',
        url: `${BASE_PATH_API}/billing/subscription/preview`
    },
    defaultPaymentMethod: {
        method: 'POST',
        url: `${BASE_PATH_API}/billing/defaultPaymentMethod`
    },
    getPaymentMethod: {
        method: 'GET',
        url: `${BASE_PATH_API}/billing/paymentMethod`
    },
    getCurrentAndNextCharge: {
        method: 'GET',
        url: `${BASE_PATH_API}/billing/currentAndNextCharge`
    },
    getAccountInfo: {
        method: 'GET',
        url: `${BASE_PATH_API}/billing/account`
    },
    getAccountSummary: {
        method: 'GET',
        url: `${BASE_PATH_API}/billing/accountSummary`
    },
    getSubscriptionContactInfo: {
        method: 'GET',
        url: `${BASE_PATH_API}/billing/subscription/buildiumcontact`
    },
    getAccountSubscriptionSummary: {
        method: 'GET',
        url: `${BASE_PATH_API}/account/planSummary`
    },
    getVendorInsuranceSettings: {
        method: 'GET',
        url: `${BASE_PATH_API}/settings/vendorInsuranceSettings`
    },
    saveVendorInsuranceSettings: {
        method: 'PUT',
        url: `${BASE_PATH_API}/settings/vendorInsuranceSettings`
    },
    getInvoicesReportPdf: {
        method: 'GET',
        url: `${BASE_PATH_API}/billing/invoices/report`
    },
    getManagementFee: {
        method: 'GET',
        url: `${BASE_PATH_API}/settings/managementfee`
    },
    getCustomFiscalYearsOverridden: {
        method: 'GET',
        url: `${BASE_PATH_API}/customFiscalYearsOverridden`
    },
    getCustomFiscalYear: {
        method: 'GET',
        url: `${BASE_PATH_API}/customFiscalYear`
    },
    saveCustomFiscalYear: {
        method: 'POST',
        url: `${BASE_PATH_API}/customFiscalYear`
    },
    getUserSettings: {
        method: 'GET',
        url: `${BASE_PATH_API}/settings/userSettings`
    },
    saveUserSettings: {
        method: 'PUT',
        url: `${BASE_PATH_API}/settings/userSettings`
    },
    saveUserNotificationSettings: {
        method: 'PUT',
        url: `${BASE_PATH_API}/settings/userNotifications`
    },
    savePassword: {
        method: 'PUT',
        url: `${BASE_PATH_API}/settings/password`
    },
    isPaymentActivated: {
        method: 'GET',
        url: `${BASE_PATH_API}/paymentSettings/isPaymentActivated`
    },
    getApplicationBranding: {
        method: 'GET',
        url: `${BASE_PATH_API}/settings/applicationBranding`
    },
    saveApplicationBranding: {
        method: 'POST',
        url: `${BASE_PATH_API}/settings/applicationBranding`
    },
    getEvents: {
        method: 'GET',
        url: `${BASE_PATH_API}/settings/:entityType/events`
    },
    getStrongroomSettings: {
        method: 'GET',
        url: `${BASE_PATH_API}/settings/strongroomSettings`
    },
    saveStrongroomSettings: {
        method: 'PUT',
        url: `${BASE_PATH_API}/settings/strongroomSettings`
    },
    getEsignatureSettings: {
        method: 'GET',
        url: `${BASE_PATH_API}/settings/esignatureSettings`
    },
    saveEsignatureSettings: {
        method: 'PUT',
        url: `${BASE_PATH_API}/settings/esignatureSettings`
    },
    getExternalApiSettings: {
        method: 'GET',
        url: `${BASE_PATH_API}/settings/externalApiSettings`
    },
    saveExternalApiSettings: {
        method: 'PUT',
        url: `${BASE_PATH_API}/settings/externalApiSettings`
    },
    getTextingSettings: {
        method: 'GET',
        url: `${BASE_PATH_API}/settings/textingSettings`
    },
    saveTextingSettings: {
        method: 'PUT',
        url: `${BASE_PATH_API}/settings/textingSettings`
    },
    getTwoFactorAuthUsers: {
        method: 'GET',
        url: `${BASE_PATH_API}/settings/twoFactorAuthUsers`,
        isArray: true
    },
    sendTwoFactorCode: {
        method: 'PUT',
        url: `${BASE_PATH_API}/settings/sendTwoFactorCode`
    },
    verifyTwoFactorCode: {
        method: 'PUT',
        url: `${BASE_PATH_API}/settings/verifyTwoFactorCode`
    },
    updatePaymentSetting: {
        method: 'PUT',
        url: `${BASE_PATH_API}/paymentSettings`
    },
    getPaymentMethodSettingsForProperty: {
        method: 'GET',
        url: `${BASE_PATH_API}/paymentMethodSettings/property/:propertyId`
    },
    getPaymentMethodSettingsForLease: {
        method: 'GET',
        url: `${BASE_PATH_API}/paymentMethodSettings/lease/:leaseId`
    },
    updatePaymentReminderSettings: {
        method: 'PUT',
        url: `${BASE_PATH_API}/paymentSettings/paymentReminders`
    },
    deletePaymentReminderSettings: {
        method: 'DELETE',
        url: `${BASE_PATH_API}/paymentSettings/paymentReminders`
    },
    getRentalOwnerStatementSettings: {
        method: 'GET',
        url: `${BASE_PATH_API}/settings/rentalOwnerStatement`
    },
    saveRentalOwnerStatementSettings: {
        method: 'PUT',
        url: `${BASE_PATH_API}/settings/rentalOwnerStatement`
    },
    updatePaymentAllocationSetting: {
        method: 'POST',
        url: `${BASE_PATH_API}/paymentSettings/paymentAllocation`
    },
    deletePaymentAllocationSetting: {
        method: 'DELETE',
        url: `${BASE_PATH_API}/paymentSettings/paymentAllocation/:id`
    },
    getManagementFeesToCollect: {
        method: 'GET',
        url: `${BASE_PATH_API}/settings/managementFeePolicy/collect`,
        isArray: true
    },
    postManagementFeesToCollect: {
        method: 'POST',
        url: `${BASE_PATH_API}/settings/managementFeePolicy/collect`,
        transformRequestData: function transformRequestData(data) {
            if (data && data.id && data.Id) {
                delete data.id;
            }

            return data;
        }
    },
    getRentalApplicationSettingsInformation: {
        method: 'GET',
        url: `${BASE_PATH_API}/applicationDefinitions`
    },
    getRentalApplicationAccountSettings: {
        method: 'GET',
        url: `${BASE_PATH_API}/applicationDefinitions/accountSettings`
    },
    updateCosignerApplicationAccountSettings: {
        method: 'PUT',
        url: `${BASE_PATH_API}/applicationDefinitions/cosignerAccountSettings`
    },
    reOrderRentalApplicationSections: {
        method: 'PUT',
        url: `${BASE_PATH_API}/applicationDefinitions/:id/reorderSections`
    },
    updateRentalApplicationSectionOrderChanges: {
        method: 'PUT',
        url: `${BASE_PATH_API}/applicationDefinitions/:id/publishChanges`
    },
    revertRentalApplicationSectionOrderChanges: {
        method: 'PUT',
        url: `${BASE_PATH_API}/applicationDefinitions/:id/revertChanges`
    },
    deleteRentalApplicationSection: {
        method: 'DELETE',
        url: `${BASE_PATH_API}/applicationDefinitions/:id/sections/:sectionId`
    },
    updateRentalApplicationDisplaySettings: {
        method: 'PUT',
        url: `${BASE_PATH_API}/applicationDefinitions/:id/displaySettings`
    },
    getDefaultManagementFeePolicy: {
        method: 'GET',
        url: `${BASE_PATH_API}/settings/managementFeePolicy`
    },
    createRentalApplicationSection: {
        method: 'POST',
        url: `${BASE_PATH_API}/applicationDefinitions/:id/sections`
    },
    updateRentalApplicationSection: {
        method: 'PUT',
        url: `${BASE_PATH_API}/applicationDefinitions/:id/sections/:sectionId`
    },
    getRentalApplicationFeeSettings: {
        method: 'GET',
        url: `${BASE_PATH_API}/applicationDefinitions/rentalApplicationFeeSettings`
    },
    getRentalApplicationCosignerAccountSettings: {
        method: 'GET',
        url: `${BASE_PATH_API}/applicationDefinitions/rentalApplicationCosignerAccountSettings`
    },
    updateRentalApplicationFeeSettings: {
        method: 'PUT',
        url: `${BASE_PATH_API}/applicationDefinitions/fee`
    },
    updateRentalApplicationPaymentMethodSettings: {
        method: 'PUT',
        url: `${BASE_PATH_API}/applicationDefinitions/paymentMethodSettings`
    },
    getRentalApplicationFeeOverrides: {
        method: 'GET',
        url: `${BASE_PATH_API}/applicationDefinitions/rentalApplicationFeeOverrides`,
    },
    getRentalApplicationFeeOverrideCount: {
        method: 'GET',
        url: `${BASE_PATH_API}/applicationDefinitions/rentalApplicationFeeOverrides/count`,
    },
    updateRentalApplicationFeeOverride: {
        method: 'PUT',
        url: `${BASE_PATH_API}/applicationDefinitions/rentalApplicationFeeOverrides`
    },
    deleteRentalApplicationFeeOverride: {
        method: 'DELETE',
        url: `${BASE_PATH_API}/applicationDefinitions/rentalApplicationFeeOverridesDelete`
    },
    getExternalApiAccessKeys: {
        method: 'GET',
        url: `${BASE_PATH_API}/accessKeys`
    },
    getWebhooks: {
        method: 'GET',
        url: `${BASE_PATH_API}/v1/webhooks`
    },
    getWebhook: {
        method: 'GET',
        url: `${BASE_PATH_API}/v1/webhooks/:webhookId`
    },
    getAvailableWebhookEvents: {
        method: 'GET',
        url: `${BASE_PATH_API}/v1/webhooks/eventtypes`
    },
    createWebhook: {
        method: 'POST',
        url: `${BASE_PATH_API}/v1/webhooks`
    },
    updateWebhook: {
        method: 'PUT',
        url: `${BASE_PATH_API}/v1/webhooks/:webhookId`
    },
    deleteWebhook: {
        method: 'DELETE',
        url: `${BASE_PATH_API}/v1/webhooks/:webhookId`
    },
    generateWebhookSecretKey: {
        method: 'POST',
        url: `${BASE_PATH_API}/v1/webhooks/secretkeys`
    },
    getApiManagementPermissions: {
        method: 'GET',
        url: `${BASE_PATH_API}/apiManagement/permissions`
    },
    doesUnprocessedCreditCardRentalApplicationFeesExists: {
        method: 'GET',
        url: `${BASE_PATH_API}/applications/unprocessedCreditCardRentalApplicationFeesExists`
    },
    getUnprocessedCreditCardRentalApplicationFeesByBank: {
        method: 'GET',
        url: `${BASE_PATH_API}/applications/:bankAccountId/unprocessedCreditCardRentalApplicationFeesByBank/:propertyId`
    },
    getDefaultTerms: {
        method: 'GET',
        url: `${BASE_PATH_API}/settings/renewal/defaultTerms`,
    },
    upsertDefaultTerms: {
        method: 'POST',
        url: `${BASE_PATH_API}/settings/renewal/defaultTerms`,
    },
    saveDefaultResidentSettings: {
        method: 'POST',
        url: `${BASE_PATH_API}/settings/resident/default`
    },
    getManagementFeeAccounts: {
        method: 'GET',
        url: `${BASE_PATH_API}/settings/managementFeePolicy/managementFeeAccounts`
    },
    getUserEmailPreference: {
        method: 'GET',
        url: `${BASE_PATH_API}/settings/useremailpreference/:userLeaseId`
    },
    getUserEmailSignature: {
        method: 'GET',
        url: `${BASE_PATH_API}/settings/useremailsignature`
    },
    updateUserEmailSignature: {
        method: 'PUT',
        url: `${BASE_PATH_API}/settings/useremailsignature`
    },
    getApplicationFeeSettings: {
        method: 'GET',
        url: `${BASE_PATH_API}/settings/rentalApplicationFeeSettings`
    },
    getAccountLockoutInformation: {
        method: 'GET',
        url: `${BASE_PATH_API}/settings/accountLockoutInformation`
    },
    paymentReminderCommunicationSetting: {
        method: 'GET',
        url: `${BASE_PATH_API}/communicationSettings/paymentReminder`
    },
    includeLiabilitiesOnStatement: {
        method: 'GET',
        url: `${BASE_PATH_API}/communicationSettings/includeLiabilitiesOnStatement`
    },
    updateCommunicationSetting: {
        method: 'POST',
        url: `${BASE_PATH_API}/communication/communicationsettings`
    },
    getGlobalPaymentAllocationSetting: {
        method: 'GET',
        url: `${BASE_PATH_API}/paymentSettings/paymentAllocation`
    },
    updatePartialPaymentsSetting: {
        method: 'PUT',
        url: `${BASE_PATH_API}/paymentSettings/partialPaymentsSetting`
    },
    getBankAccountsForRentalApplication: {
        method: 'GET',
        url: `${BASE_PATH_API}/applicationDefinitions/rentalApplications/bankAccounts`,
        isArray: true
    },
    getBankAccountsForRentalApplicationFee: {
        method: 'GET',
        url: `${BASE_PATH_API}/applicationDefinitions/rentalApplications/fee/bankAccounts`,
        isArray: true
    },
    isScreeningEnabledWithSubscription: {
        method: 'GET',
        url: `${BASE_PATH_API}/settings/screeningEnabledWithSubscription`
    },
    getGlobalRentalApplicationInfo: {
        method: 'GET',
        url: `${BASE_PATH_API}/applications/fees/global`,
    },
    isSubscriptionAllowedBankAccount: {
        method: 'GET',
        url: `${BASE_PATH_API}/settings/subscription/isSubscriptionAllowedBankAccount`,
    },
    getBillingInfoFlagForAccount: {
        method: 'GET',
        url: `${BASE_PATH_API}/settings/subscription/getBillingInfoFlagForAccount`,
    },
    processAccountOutstandingPayment: {
        method: 'POST',
        url: `${BASE_PATH_API}/settings/subscription/processAccountOutstandingPayment`,
    },
    isCosignerSectionInApplicantApplication: {
        method: 'GET',
        url: `${BASE_PATH_API}/applicationDefinitions/isCosignerSectionInApplicantDefinition`,
    },
    getLeasePartialPaymentSetting: {
        method: 'GET',
        url: `${BASE_PATH_API}/leases/:id/paymentSettings/partialPaymentSettings`
    },
    getLeasePartialPaymentSettingSummary: {
        method: 'GET',
        url: `${BASE_PATH_API}/leases/:id/paymentSettings/partialPaymentSettingsSummary`
    },
    setLeasePartialPaymentSetting: {
        method: 'PUT',
        url: `${BASE_PATH_API}/leases/:id/paymentSettings/partialPaymentSettings`
    },
    removeLeasePartialPaymentSetting: {
        method: 'DELETE',
        url: `${BASE_PATH_API}/leases/:id/paymentSettings/partialPaymentSettings`
    },
    getOwnershipAccountPartialPaymentSetting: {
        method: 'GET',
        url: `${BASE_PATH_API}/ownership-accounts/:id/paymentSettings/partialPaymentSettings`
    },
    getOwnershipAccountPartialPaymentSettingSummary: {
        method: 'GET',
        url: `${BASE_PATH_API}/ownership-accounts/:id/paymentSettings/partialPaymentSettingsSummary`
    },
    setOwnershipAccountPartialPaymentSetting: {
        method: 'PUT',
        url: `${BASE_PATH_API}/ownership-accounts/:id/paymentSettings/partialPaymentSettings`
    },
    removeOwnershipAccountPartialPaymentSetting: {
        method: 'DELETE',
        url: `${BASE_PATH_API}/ownership-accounts/:id/paymentSettings/partialPaymentSettings`
    },
    getDefaultUnitSettings: {
        method: 'GET',
        url: `${BASE_PATH_API}/settings/defaultUnit`
    },
    getAutomatedTenantScreeningSettings: {
        method: 'GET',
        url: `${BASE_PATH_API}/settings/automatedTenantScreening`
    },
    updateAutomatedTenantScreeningSettings: {
        method: 'POST',
        url: `${BASE_PATH_API}/settings/automatedTenantScreening`
    },
    getAutomatedTenantScreeningChargeApplicantSetting: {
        method: 'GET',
        url: `${BASE_PATH_API}/settings/automatedTenantScreening/chargeApplicants`
    }
};
export function SettingsApi(
    $q,
    $httpParamSerializer
) {
    const service = createActions(actions);

    service.getOverridesExport = function getOverridesExport(params) {
        return `${BASE_PATH_API}/applicationDefinitions/rentalApplicationFeeOverrides/export?${$httpParamSerializer(params)}`;
    };

    service.isManagementFeePolicySet = function isManagementFeePolicySet() {
        return service.getManagementFee()
            .then(() => true)
            .catch(response => {
                if (response.status === 404) {
                    return false;
                }
                return $q.reject(response);
            });
    };
    return service;
}
SettingsApi.$inject = [
    '$q',
    '$httpParamSerializer'
];
